module.exports = __webpack_public_path__ + "static/media/assessment.fddd4404.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainmenus/assessment.png
// module id = 2926
// module chunks = 0